"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const createTransaction = (_) => {
    return {
        family: "solana",
        amount: new bignumber_js_1.BigNumber(0),
        useAllAmount: false,
        recipient: "",
        model: {
            kind: "transfer",
            uiState: {
                memo: undefined,
            },
        },
    };
};
exports.default = createTransaction;
//# sourceMappingURL=js-createTransaction.js.map